<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-6 col-lg-6">
                <div class="trinka-title">
                    <h3 class="text-white mb-4">支援多國貨幣發票，<br/>簡化帳務流程</h3>
                    <p class="text-white">Trinka 支援多種本地貨幣開立發票（如：日本 Seikyu-sho、中國發票、韓國收據、土耳其 Fatura 等），包含 JPY、CNY、BRL、TRY、KRW、INR、USD、EUR、TWD 等多國幣別。企業也可將多個帳戶合併為單一在地貨幣發票，簡化會計流程。</p>
                    <div class="btn-group">
                        <a [routerLink]="['/local-invoice']" class="white-btn">查看發票選項</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-6">
                <div class="text-center">
                    <img src="/assets/images/enterprise/local-inovice-element.webp" width="473" height="418" alt="local invoice" class="img-fluid" />
                </div>
            </div>
        </div>  
    </div>
</section>